module.exports = __webpack_public_path__ + "static/media/bitcoin_transaction_bitcoin-studio.415b5489.jpg";